module.exports = __webpack_public_path__ + "img/isabel_village1.1f856907.png";